<template>
  <div class="dashboard-container">
    <el-row v-if="!showStepControl" style="margin-bottom: 14px;" >
      <el-col :span="24">
        <step-control  />
      </el-col>
    </el-row>
    <table-control/>
    <bind-email-dialog :viewVisible="dialogVisible" @close="dialogVisible = false"/>
  </div>
</template>

<script>
import { reactive, toRefs, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from '@/plugins/i18n'
import { routeTo } from '@/utils'
import { commonUtils } from '@libs/utils'
import BindEmailDialog from '@/components/BindEmailDialog'
import StepControl from './components/step-controlV2'
import TableControl from './components/table-controlV2'
import { getRegisterInfo } from "@/utils/common-req"
import { getBankAcct } from "@/api/modules/auth"

export default {
  components: {
    StepControl,
    TableControl,
    BindEmailDialog,
  },
  setup() {
    const { t, isLocal } = useI18n()
    const store = useStore()
    const userInfo = computed(() => store.state.user.userInfo)
    const scopedComp = {
      routeTo,
      t,
      isLocal,
      isEmpty: commonUtils.isEmpty,
      // template
    }
    const _initStep = initStep()
    const _initBankCard = initBankCard()
    const state = reactive({
      dialogVisible: false
    })
    const scopedMethods = {}
    watch(() => userInfo.value, value => {
      if (!value.email) {
        state.dialogVisible = true
      }
    }, { immediate: true })
    getRegisterInfo()

    return {
      ...toRefs(state),
      ...toRefs(_initStep),
      ...toRefs(_initBankCard),
      ...scopedComp,
      ...scopedMethods,
      ...initDialog(), // 初始化弹框
    }
  }
}

// 弹框相关逻辑
const initDialog = () => {

}

// 初始化银行卡
const initBankCard = () => {
  const state = reactive({
    bankList: []
  })
  const scopedMethods = {
    initBankData: async () => {
      const res = await getBankAcct()
      state.bankList = res?.list || []
    }
  }
  scopedMethods.initBankData()
  return { ...toRefs(state), ...scopedMethods }
}

const initStep = () => {
  const store = useStore()
  const state = reactive({
    registerInfo: store.state.auth.registerInfo,
  })
  const showStepControl = computed(() => {
    return state.registerInfo?.agreementReviewStatus === "CF"
  })
  return { ...toRefs(state), showStepControl }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .dashboard-container {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border-radius: 4px;
    overflow-y: auto;
    overflow-x: hidden;

    .el-row {
      // margin-bottom: 14px;
    }
  }
</style>
